const DrainageResourceQuery = () =>
  import('@/views/main/wechatMgmt/drainageResourceQuery/DrainageResourceQuery.vue')
export default {
  path: '/main/wechatMgmt/drainageResourceQuery',
  name: 'DrainageResourceQuery',
  component: DrainageResourceQuery
}
